import { Route, Routes } from 'react-router'

import { NotFound } from 'js/core/NotFound'

import Item from './Item'

export const PageRoutes = () => (
    <Routes>
        <Route path="view/:guid" element={<Item />} />
        <Route path="view/:guid/:slug" element={<Item />} />
        <Route
            path="view/:containerGuid/:containerSlug/:guid"
            element={<Item />}
        />
        <Route path="*" element={<NotFound />} />
    </Routes>
)
